// Circuitos bloqueados - no pueden usar el sistema web
// Lista vacía: actualmente no se bloquea ningún circuito.
// Para volver a bloquear, agregar los nombres de los circuitos a este arreglo.
export const BLOCKED_CIRCUITS = [];

/**
 * Verifica si un circuito está bloqueado
 * @param {string} circuito - Código del circuito
 * @returns {boolean} - true si está bloqueado
 */
export const isCircuitBlocked = (circuito) => {
  if (!circuito) return false;
  return BLOCKED_CIRCUITS.includes(circuito.toString());
};

/**
 * Mensaje de error para usuarios con circuito bloqueado
 */
export const getBlockedCircuitMessage = () => {
  return 'El acceso web no está disponible para tu zona de reparto. Por favor, contactá con atención al cliente al 0810 444 7272 o vía WhatsApp al 5493435031261.';
};
